import React from 'react';
import { useNavigate } from 'react-router-dom';

const RangoWidget = () => {
    const navigate = useNavigate();

    return (
        <div id="tour-rango-widget">
            <div className="card account-card overflow-hidden border-0 shadow-sm mt-0">
                <div className="">
                    <h5 className="text-center mb-6 font-semibold text-lg">Buy KAX Tokens with Crypto</h5>

                    <div className="flex items-center justify-between bg-white dark:bg-gray-800/10 rounded-xl mb-6 border border-gray-100 dark:border-gray-800 shadow-sm">
                        <div className="flex items-center gap-3 p-3">
                            <div className="w-14 h-14 rounded-full overflow-hidden bg-white flex items-center justify-center p-0  border border-gray-50">
                                <img
                                    src="https://api.rango.exchange/blockchains/polygon.svg"
                                    alt="Rango"
                                    className="w-10 h-10 object-contain"
                                />
                            </div>
                            <div>
                                <div className="font-weight-600 text-xl">Rango</div>
                                <div className="text-gray-500">Exchange</div>
                            </div>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-100 p-3 rounded-xl">
                            <div className="">
                                <img
                                    src="https://api.rango.exchange/tokens/POLYGON/KAX.png"
                                    alt="KAX"
                                    className="w-10 h-10 object-contain"
                                />
                            </div>
                            <div className="">
                                <div className="font-semibold text-xl">KAX</div>
                                <div className="text-gray-500">Polygon</div>
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={() => navigate('/rango-exchange')}
                        className="modal-button flex items-center gap-2 justify-content-center primary w-full"
                    >
                        Buy Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RangoWidget;
